<template>
  <div class="help_detail">
    <div class="header">
      <div class="header_top">
        <router-link tag="div" class="logo_search" :to="{path:'/'}">
          <img src="@/assets/logo/logo_horizontal.svg" alt="游选">
        </router-link>
        <el-input
          placeholder="请输入问题关键词"
          class="search_input"
          @keydown.enter.native="handleSearch"
          v-model.trim="keyWord">
          <span slot="prefix">
            <img src="@/assets/image/HelpCenter/search.png">
          </span>
        </el-input>
      </div>
    </div>
    <div class="detail_box">
      <div class="detail_main">
        <div class="main_left" id="main_left">
          <el-menu
            :default-active="default_active"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose">
            <el-submenu index="all">
              <template slot="title">
                <span>全部问题</span>
              </template>
              <el-submenu
                :index="item.cat_id.toString()"
                v-for="item in menu"
                :key="item.cat_id">
                <template slot="title">{{ item.cat_name }}</template>
                <el-menu-item
                  :index="item.cat_id.toString()+'-'+child.id.toString()"
                  v-for="child in item.list"
                  @click="handleHelp(item.cat_id,child.id,child.title)"
                  :key="item.cat_id+'-'+child.id">
                  {{ child.title }}</el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
        </div>
        <div class="main_right">
          <div class="main_right_top">
            <!-- <a @click="$router.back(-1)">返回</a> -->
            <router-link :to="{name:'helpCenter'}">返回</router-link>
                /
            全部问题 {{ sort_title ? ' / '+sort_title : '' }} {{ qes_title ? ' / '+qes_title : '' }}
          </div>
          <div class="main_right_wrapper">
              <div class="main_content ql-container ql-snow">
                <p class="ql-editor" v-html="content"></p>
              </div>
            <div class="main_content_right">
              <div
                class="letter_title"
                :class="{'active': right_index==index}"
                v-for="(item, index) in GuideFixed"
                @click="jump(item,index)"
                :key="index">
                {{ item.innerText }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiHelpCenter, apiHelpDetail } from "@/request/API";
export default {
  name: 'helpDetail',
  data() {
    return {
      keyWord: '',
      id: '',
      cat_id: '',
      content: '',
      menu: [],
      // 问题标题
      qes_title: '',
      // 分类标题
      sort_title: '',
      default_active: '',
      // 右侧小标题
      letter_title: [],
      GuideFixed: [],
      // scroll: '',
      right_index: 0
    }
  },
  created() {
    this.id = this.$route.query?.id
    this.cat_id = this.$route.query?.cat_id
    this.getMenuData()
    if(this.cat_id){
      this.handeleGetData()
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  methods: {
     onScroll(e) {
      let scrollItems = document.querySelectorAll('h2')
      // console.log(document.documentElement.scrollTop);
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge =
          document.documentElement.scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop
        if (judge) {
          this.right_index = i
          break
        }
      }
      //滚动条触底了
      if (
        e.srcElement.scrollTop + e.srcElement.offsetHeight ==
        e.srcElement.scrollHeight
      ) {
        if (this.GuideFixed) {
          this.right_index = this.GuideFixed.length - 1
        } else {
          this.right_index = this.quizFixed.length - 1
        }
      }
    },
    /**
     * @description: 右侧锚点跳转定位
     * @param item
     * @return {*}
     */
    jump(item, index) {
      item.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
      this.right_index=index
    },
    /**
     * @description: 点击左侧菜单显示不同内容
     * @param cat_id 父id
     * @param id 当前数据id
     * @return {*}
     */
    handleHelp(cat_id, id) {
      this.cat_id = cat_id,
      this.id = id
      this.right_index = 0
      this.GuideFixed = []
      this.$router.push({
        name: 'helpDetail',
        query: {id: this.id,cat_id: this.cat_id}
      })
      this.handeleGetData()
    },
    /**
     * @description: 获取左侧菜单
     * @return {*}
     */
    getMenuData() {
      apiHelpCenter().then(res => {
        this.menu = res.data
      })
    },
    /**
     * @description: 搜索
     * @return {*}
     */
    handleSearch() {
      this.$router.push({
        name:'helpCenterSearch',
        query:{
          keyWord: this.keyWord
        }
      })
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    /**
     * @description: 获取问题详情
     * @return {*}
     */
    handeleGetData() {
      apiHelpDetail({
        id: this.id,
        cat_id: this.cat_id
      }).then(res => {
        this.content = res.data.list[0].content
        this.default_active = `${this.cat_id}-${this.id}`
        this.qes_title = res.data.list[0].title
        this.sort_title = res.data.list[0].cat_name
        this.$nextTick(() => {
          let ghead = document.getElementsByTagName('h2');
          this.GuideFixed = ghead
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.help_detail{
  width: 100vw;
  min-height: 100vh;
  background: var(--bg-page, #F7F5F2);
  .header{
    position: relative;
    z-index: 2;
    background: var(--bg-card, #FFFFFF);
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 8px 24px rgba(26, 29, 36, 0.08);
    .header_top{
      width: 1200px;
      height: 78px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo_search{
        width: 220px;
        height: 78px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img{
          margin: 1px 0 0 0;
          width: 100%;
          height: 58px;
          object-fit: contain;
          object-position: left center;
        }
      }
      .search_input{
        width: 420px;
        height: 42px;
        background: #FFFFFF;
        border: 2px solid var(--primary, #FF5A1F);
        border-radius: 3px;
        box-shadow: none;
        /deep/input{
          height: 42px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 300;
          color: var(--text-main, #111827);
          border: none;
          border-radius: 3px;
          padding-left: 48px;
          padding-right: 20px;
          background: transparent;
        }
        /deep/input::-webkit-input-placeholder{
          color: var(--text-muted, #9AA0AC);
        }
        /deep/.el-input__prefix{
          width: 18px;
          height: 18px;
          top: calc(50% - 9px);
          left: 22px;

          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .detail_box{
    min-height: calc(100vh - 78px);
    background: var(--bg-page, #F7F5F2);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 18px 0 28px;
    box-sizing: border-box;
    .detail_main{
      width: 1200px;
      display: flex;
      align-items: stretch;
      gap: 18px;
      min-height: calc(100vh - 124px);
      .main_left{
        flex: 0 0 280px;
        align-self: stretch;
        min-height: calc(100vh - 124px);
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        padding: 18px 12px;
        box-sizing: border-box;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        &#main_left ul li ul li {
          /deep/.el-submenu__icon-arrow{
            right: auto;
            left: 18px;
          }
        }
        /deep/.el-submenu__icon-arrow{
          right: auto;
          left: 0;
          transform: rotateZ(-90deg);
          color: var(--text-muted, #9AA0AC);
        }
        .el-menu{
          border: none;
          background: transparent;
        }
        /deep/.el-menu-item, /deep/.el-submenu__title{
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          transition: color 0.2s ease, background 0.2s ease;
        }

        /deep/.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
          transform: rotateZ(0deg);
        }
        /deep/ .is-active > .el-submenu__title {
          color: var(--text-main, #1A1D24) !important;

          div {
            background: var(--bg-tag, #F0EDE8) !important;
          }
        }
        /deep/ .el-submenu__title:hover, .el-submenu__title:focus {
          color: var(--text-main, #1A1D24);
          background: var(--bg-tag, #F0EDE8);
        }
        .el-menu-item:focus, .el-menu-item:hover{
          color: var(--text-main, #1A1D24);
          background: var(--bg-tag, #F0EDE8);
        }
        /deep/.el-menu-item.is-active{
          color: var(--primary, #FF5A1F);
          background: var(--bg-tag, #F0EDE8);
        }
         /deep/ .el-submenu > .el-menu--inline > .is-active .is-active {
          background: var(--bg-tag, #F0EDE8);
          color: var(--primary, #FF5A1F);
          padding-left: 40px !important;
          position: relative;
          &::before{
            content: '';
            position: absolute;
            top: 8px;
            left: 0;
            width: 3px;
            height: 24px;
            background: var(--primary, #FF5A1F);
            border-radius: 3px;
          }
        }
      }
      .main_right{
        min-width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 18px;
        .main_right_top{
          min-height: 58px;
          background: var(--bg-card, #FFFFFF);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          line-height: 22px;
          padding: 16px 22px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
          a{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 58px;
            height: 28px;
            padding: 0 14px;
            background: transparent;
            border: 1px solid var(--text-main, #1A1D24);
            border-radius: 3px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: var(--text-main, #1A1D24);
            line-height: 28px;
            text-align: center;
            margin-right: 10px;
            cursor: pointer;
            box-sizing: border-box;
            transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

            &:hover {
              color: #FFFFFF;
              background: var(--text-main, #1A1D24);
              border-color: var(--text-main, #1A1D24);
            }
          }
        }
        .main_right_wrapper{
          display: flex;
          align-items: flex-start;
          gap: 18px;
          .main_content{
            min-width: 0;
            flex: 1;
            min-height: calc(100vh - 200px);
            padding: 28px 34px 40px;
            background: var(--bg-card, #FFFFFF);
            border: 1px solid var(--border-soft, #E8E4DE) !important;
            border-radius: 4px;
            box-sizing: border-box;
            box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
            img{
              width: 100% !important;
              border-radius: 4px;
            }
            .ql-editor{
              padding: 0;
              margin: 0;
              font-size: 15px;
              line-height: 28px;
              color: var(--text-secondary, #5A5F6B);
            }
          }
          .main_content_right{
            position: sticky;
            top: 18px;
            flex: 0 0 220px;
            min-height: 260px;
            padding: 16px 12px;
            background: var(--bg-card, #FFFFFF);
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            box-sizing: border-box;
            box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
            .letter_title{
              min-height: 36px;
              line-height: 20px;
              padding: 8px 12px 8px 18px;
              border-radius: 4px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
              cursor:pointer;
              box-sizing: border-box;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              transition: color 0.2s ease, background 0.2s ease;

              &:hover {
                color: var(--brand-blue, #1A1D24);
                background: var(--bg-tag, #F0EDE8);
              }
            }
            .active{
              background: var(--bg-tag, #F0EDE8);
              border-left: 3px var(--primary, #FF5A1F) solid;
              color: var(--primary, #FF5A1F);
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
  .detail_box{
    .ql-container.ql-snow{
      border: none !important;
    }
    .ql-editor{
      h2 {
        margin: 0 0 14px;
        padding-top: 10px;
        font-size: 20px;
        line-height: 30px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: var(--text-main, #111827);
      }

      h2 + p {
        margin-top: 0;
      }

      p {
        margin: 0 0 14px;
        font-size: 15px;
        line-height: 28px;
        color: var(--text-secondary, #5A5F6B);
      }
    }
  }
</style>
